import getData from './api';
import { groupBy } from 'lodash';

export function getWorkflowNameAndVersion(hash: string) {
  const [workflowName, workflowVersion = '0'] = hash.split('/').slice(3, 5);

  return {
    workflowName,
    workflowVersion: parseInt(workflowVersion)
  };
}

export function getCurrentWorkflowFieldUsage(fieldsPath?: string | null) {
  const { workflowName, workflowVersion } = getWorkflowNameAndVersion(window.location.hash);

  return getData({ workflowName, version: workflowVersion, fieldsPath })
    .then((response: { data?: { FieldsUsages: any }[] }) => {
      const data = response.data;

      const groupFn = (item: any) => `${item.ItemId}-${item.ItemType}-${item.ScriptType}-${item.RuleIndex || 0}`;
      const grouped = groupBy((data && data[0]?.FieldsUsages) || [], groupFn)
      const dependencies = Object.values(grouped).map(g => g[0]);
      return dependencies;
    });
}
